import MoodsTable from "./MoodsTable";

export default MoodsTable;